/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Dropdown, theme } from "@nordcloud/gnui";
import { useBusinessContextsMinimalQuery } from "~/generated/graphql";

type Props = {
  value: string;
  onChange: (contextId: string) => void;
};

export function BusinessContextSelector({ value, onChange }: Props) {
  const { data } = useBusinessContextsMinimalQuery({
    variables: { limit: 100, page: 0 },
  });

  const businessContexts = data?.businessContexts?.businessContexts ?? [];

  const options = businessContexts.map((context) => ({
    label: context.name,
    value: context.id,
  }));

  return (
    <Dropdown
      name="Select Business Context..."
      value={value}
      options={options}
      onChange={onChange}
      mt={theme.spacing.spacing04}
    />
  );
}
